module.exports = __webpack_public_path__ + "media/images/users/family_happy-85f4d1c6694f90e4074f31e85b0d5ab0.jpg";